import { apiService } from './apiService';

export interface NotificationGroup {
    "@id": string;
    "@type": "NotificationGroup";
    id: number;
    label: string;
}

export interface NotificationType {
    "@id": string;
    "@type": "NotificationType";
    id: number;
    label: string;
}

export interface NotificationListItem {
    "@id": string;
    "@type": "NotificationList";
    id: number;
    label: string;
    notificationGroup: NotificationGroup;
    notificationType: NotificationType;
}

export interface NotificationResponse {
    "@context": string;
    "@id": string;
    "@type": string;
    "member": NotificationListItem[];
}

export interface NotificationSetting {
  "@id": string;
  id: number;
  label: string
}

export interface UserNotificationSetting {
    "@context": string;
    "@id": string;
    "@type": string;
    "id": number;
    "workplace": string;
    "users": string;
    "notifications": NotificationSetting;
    "email": boolean;
    "sms": boolean;
    "push": boolean;
}

export interface UserNotificationResponse {
    "@context": string;
    "@id": string;
    "@type": string;
    "hydra:member": UserNotificationSetting[];
}

class NotificationService {
    async getNotificationLists(): Promise<NotificationListItem[]> {
        try {
            const response = await apiService.get<NotificationResponse>('notification_lists');
            return apiService.responseHandler(response).member;
        } catch (error) {
            console.error('Error fetching notifications:', error);
            return [];
        }
    }

    async getUserNotificationSettings(): Promise<UserNotificationSetting[]> {
        try {
            const response = await apiService.get<UserNotificationResponse>('/user_notification_settings/me');
            return apiService.responseHandler(response).member;
        } catch (error) {
            console.error('Error fetching user notification settings:', error);
            return [];
        }
    }

    async updateUserNotificationSetting(setting: Partial<UserNotificationSetting>): Promise<UserNotificationSetting> {
        const response = await apiService.put<UserNotificationSetting, Partial<UserNotificationSetting>>(
            `/user_notification_settings/${setting.id}`,
            setting
        );
        return apiService.responseHandler(response);
    }

    async createUserNotificationSetting(setting: {
        workplace: string;
        users: string;
        notifications: string;
        email: boolean;
        sms: boolean;
        push: boolean;
    }): Promise<UserNotificationSetting> {
        const response = await apiService.post<UserNotificationSetting>(
            '/user_notification_settings',
            setting
        );
        return apiService.responseHandler(response);
    }
}

export const notificationService = new NotificationService();